/**
 * GradePicker — Step 1 of the Math Engine wizard. Picks which grade's
 * SCDSB scope/sequence to load.
 */
import React from "react";
import { SUPPORTED_GRADES } from "./utils";

const GradePicker = ({ selected, onSelect }) => (
  <div
    className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3"
    data-testid="math-engine-grade-picker"
  >
    {SUPPORTED_GRADES.map((g) => (
      <button
        key={g}
        type="button"
        onClick={() => onSelect(g)}
        data-testid={`math-engine-grade-${g.replace(/\s+/g, "-")}`}
        className={`rounded-xl border-2 px-4 py-5 text-left transition-all ${
          selected === g
            ? "border-[#96ded1] bg-[#96ded1]/15 shadow-sm"
            : "border-[#4a6984]/15 bg-white hover:border-[#4a6984]/30 hover:shadow-sm"
        }`}
      >
        <p className="text-[10px] font-bold uppercase tracking-[0.18em] text-[#4a6984]/70">
          Ontario
        </p>
        <p className="mt-1 font-extrabold text-xl text-[#1c2d3d] tracking-tight">
          {g}
        </p>
      </button>
    ))}
  </div>
);

export default GradePicker;
